import axios, { AxiosError } from 'axios';
import { ConfigApi } from '@backstage/core-plugin-api';
import { CNAPCGAAudit } from '../components/insights/types/InsightsTypes';

/**
 * Fetch CNAP CGA Audit data for a given applicationId.
 * - Routes all requests through the backend proxy (/api/cnap/cga-audit/)
 *   to avoid browser CORS errors. The backend proxy in turn calls the
 *   external CNAP API server-side.
 * - Returns an empty array for 404 or any error; does not throw.
 *
 * @param config config
 * @param appId appId
 */
export async function fetchCnapData(
  config: ConfigApi,
  appId: number,
): Promise<CNAPCGAAudit[]> {
  if (!appId) return [];

  try {
    const baseProxyUrl = config.getString('app.baseUrl');
    const proxyUrl = `${baseProxyUrl}/api/cnap/cga-audit/${appId}`;

    const response = await axios.get<
      CNAPCGAAudit[] | { data?: CNAPCGAAudit[] }
    >(proxyUrl);

    const payload = response?.data;

    // The backend proxy returns the external API response body directly.
    // Handle both possible shapes: an array or an object with a `data` array.
    if (Array.isArray(payload)) {
      return payload;
    }
    if (payload?.data && Array.isArray(payload.data)) {
      return payload.data;
    }

    return [];
  } catch (err: AxiosError | any) {
    // Treat 404 as no data; for other errors, return empty
    return [];
  }
}
